<template>
  <span class="jm-education-select">
    <jm-dict-select
      class="jm-input-common2"
      v-bind="$attrs"
      type="online"
      dict-type="examjp"
      v-model="top"
      @change="changTop"
    />
    <jm-dict-select
      class="jm-input-common2"
      v-bind="$attrs"
      type="online"
      dict-type="examjp_d"
      :refresh.sync="refreshDetail"
      :filter="filter"
      @change="changeSub"
      v-model="sub"
    />
  </span>
</template>

<script>
import educationSelect from './educationSelect';

export default {
  extends: educationSelect,
  name: 'JmExamjpSelect',
};
</script>
